export default __webpack_public_path__ + "static/media/frog-look-to-right.d063c2be.png";